import React from 'react';
import { FiSend } from 'react-icons/fi';
import { FcSurvey } from 'react-icons/fc'
import useCotizacion from 'src/hooks/useCotizacion';
import useCustomRouter from 'src/hooks/useCustomRouter';
import useCustomToast from 'src/hooks/useCustomToast';
import { URL_RETORNO } from 'src/parametros';
import usePaginaPago from 'src/reducers/PaginaPago/usePaginaPago';
import { POST, guardarLead } from 'src/services';
import { urlFormaPago } from 'src/services/urls';
import { Layout } from '../styleds';
import { useHistory } from 'react-router-dom';

const PagoRoll = ({ codCore, nombre, tipo }) => {
  console.log("props:");
  const { cotizacion, idCotizacion } = useCotizacion();
  const { addSuccessToast, addWarningToast } = useCustomToast();
  const history = useHistory();
  const { valdiarTerminos, setLoading, resetLoading } = usePaginaPago();

  const router = useCustomRouter();

  const notificarClientePtp = async () => {
    guardarLead(idCotizacion, 'PAGINA_PAGO__SELECCIONO_PAGO_NOTIFICAR_CLIENTE_ROLL');

    setLoading({
      loading: true,
      principal: 'Estamos enviando el enlace de pago',
      secundario: 'Espere por favor',
    });

    const Data = {
      idCotizacion: idCotizacion,
      forma: 'ROL',
      empCodigo: 'AIGMETROPOLITANA'
    };

    const res = await POST(urlFormaPago, Data);
    if (res.transaccion && !res.error) {

      // addSuccessToast(`SE HA ENVIADO UN CORREO A ${cotizacion.titular.email}`);
      if (`${cotizacion.producto.tieneFirma}` === '1') {
        if (cotizacion.medioFirma === 'evicertia')
          return history.push(`/firmarCertificado/${idCotizacion}`);
      }
      else router.push(`/ingresarPoliza/${idCotizacion}`);
    } else {
      addWarningToast(`HA OCURRIDO UN PROBLEMA, ${res.mensaje}`);
    }
    resetLoading();
  };

  return (
    <Layout onClick={valdiarTerminos(notificarClientePtp)}>
      <div className="d-flex flex-row text-primary">
        <FcSurvey className="mr-1 mt-0" size="35" /> <h5 style={{ marginBottom: 0 }}>{nombre} </h5>
      </div>
    </Layout>
  );
};

export default PagoRoll;
